import React from "react";
import moment from 'moment'
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { useEffect } from "react";
import { logService } from '../services';

export const CallLogsPath = "/call-logs";

function CallLogs() {
  const [logs, setLogs] = React.useState([]);
  const [start, setStart] = React.useState(Math.floor(Date.now()/1000)-86400);
  const [filterSelect, setFilterSelect] = React.useState("PhoneNumber");
  const [filterContent, setFilterContent] = React.useState("");
  const [history, setHistory] = React.useState("day");
  const [triggerUpdate, setTriggerUpdate] = React.useState(false);

  useEffect(() => {
    fetchData();
    const id = window.setInterval(() => setTriggerUpdate(true), 60000);
    return () => window.clearInterval(id);
  }, []);

  useEffect(() => {
    if (triggerUpdate) {
      fetchData(Math.floor(Date.now()/1000)-86400)
      setTriggerUpdate(false)
    }
  })

  const fetchData = (update) => {
    if (!update) update = start;
    logService.getLogs(update).then(resp => {
      // prepend new data when start is used to fetch logs.
      if (update === start) {
        setLogs(logs => [...resp.Data, ...logs]);
      } else {
        setLogs(resp.Data);
      }
      if (resp.Data.length > 0) {
        setStart(new Date(resp.Data[0].CreatedAt).getTime());
      }
    });
  }

  const updateFilterSelect = (e) => {
    setFilterSelect(e.target.value);
    setFilterContent("");
  }

  const updateFilterContent = (e) => {
    setFilterContent(e.target.value);
  }

  const updateHistory = (e) => {
    let update = Math.floor(Date.now()/1000);
    if (e.target.value === "day") {
      update -= 86400;
    } else if (e.target.value === "week") {
      update -= 7*86400;
    } else if (e.target.value === "month") {
      update -= 31*86400;
    } else {
      update = 1;
    }
    fetchData(update);
    setHistory(e.target.value);
  }

  return (
    <>
      <h1 style={{fontFamily: "Ink", textAlign: "center", padding: "20px"}}>
        Call Logs</h1>
      <Grid container spacing={3} style={{padding: "20px"}}>
        <Grid item xs={3}>
          <FormControl>
            <InputLabel>Filter By</InputLabel>
            <Select value={filterSelect} onChange={updateFilterSelect}>
              <MenuItem value="PhoneNumber">Phone Number</MenuItem>
              <MenuItem value="ExternalReference">Deal ID</MenuItem>
              <MenuItem value="Stage">Stage</MenuItem>
              <MenuItem value="User">Agent</MenuItem>
              <MenuItem value="Action">Action</MenuItem>
              <MenuItem value="Priority">Priority</MenuItem>
              <MenuItem value="MarketingTracker">Tracker</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <TextField label="Filter Content" value={filterContent}
            onChange={updateFilterContent}/>
        </Grid>
        <Grid item xs={6}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Call History</FormLabel>
            <RadioGroup row aria-label="position" name="position"
              value={history}>
              <FormControlLabel value="day" control={<Radio color="primary" />}
                label="Day" labelPlacement="end" onChange={updateHistory}/>
              <FormControlLabel value="week" control={<Radio color="primary" />}
                label="Week" labelPlacement="end" onChange={updateHistory}/>
              <FormControlLabel value="month"
                control={<Radio color="primary" />} label="Month"
                labelPlacement="end" onChange={updateHistory}/>
              <FormControlLabel value="all" control={<Radio color="primary" />}
                label="All (slow)" labelPlacement="end"
                onChange={updateHistory}/>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <table>
      <thead>
        <tr>
          <th>Phone Number</th>
          <th>Deal ID</th>
          <th>Stage</th>
          <th>Agent</th>
          <th>Action</th>
          <th>Priority</th>
          <th>Tracker</th>
          <th>Disposition</th>
          <th>Created At</th>
        </tr>
      </thead>
      <tbody>
      {
        logs.map((log, i) => {
          return (filterContent === "" || (log[filterSelect] + "").toLowerCase().startsWith(filterContent.toLowerCase()) ?
            <tr key={i} style={{textAlign: "center", paddingBottom: "15px", backgroundColor: i % 2 === 0 ? '#FFF' : '#ccc'}}>
              <td>{log.PhoneNumber}</td>
              <td>{log.ExternalReference}</td>
              <td>{log.Stage}</td>
              <td>{log.User}</td>
              <td>{log.Action}</td>
              <td>{log.Priority}</td>
              <td>{log.MarketingTracker}</td>
              <td>{log.Disposition}</td>
              <td>{moment(log.CreatedAt).format('lll')}</td>
            </tr> : null
          )
        })
      }
      </tbody>
      </table>
    </>
  )
}

export default CallLogs;
